module.exports = __webpack_public_path__ + "static/media/back.ad480d46.png";